import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "../api/baseurl";
import { toast } from "react-toastify";
import { Modal, Button } from "react-bootstrap";
import "react-toastify/dist/ReactToastify.css";
import "./Spinner.css";
import "./hm-theme.css";

const AddBookingCategory = ({ isOpen, onRequestClose, categoryId, companyId }) => {
  const navigate = useNavigate();

  const [form, setForm] = useState({
    name: "",
    description: "",
    active: true,
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (categoryId) {
      const fetchCategory = async () => {
        setLoading(true);
        const token = JSON.parse(localStorage.getItem("data")).token;
        try {
          const response = await axios.get(`/api/bookingcategory/${categoryId}`, {
            headers: { Authorization: `Bearer ${token}` },
          });
          setForm({
            name: response.data.name || response.data.categoryname || "",
            description: response.data.description || "",
            active: response.data.active !== undefined ? response.data.active : true,
          });
        } catch (error) {
          handleError(error);
        } finally {
          setLoading(false);
        }
      };
      fetchCategory();
    }
  }, [categoryId]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name.trim()) {
      toast.error("Please enter a category name.");
      return;
    }
    setLoading(true);
    const token = JSON.parse(localStorage.getItem("data")).token;
    const url = categoryId
      ? "/api/bookingcategory/update"
      : "/api/bookingcategory/create";
    const data = {
      name: form.name,
      categoryname: form.name,
      description: form.description,
      companyId: companyId,
      active: form.active,
      ...(categoryId && { id: categoryId }),
    };

    try {
      await axios({
        method: "post",
        url,
        data,
        headers: { Authorization: `Bearer ${token}` },
      });
      toast.success(
        categoryId
          ? "Booking Category Updated Successfully"
          : "Booking Category Added Successfully"
      );
      setForm({ name: "", description: "", active: true });
      onRequestClose();
    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
    }
  };

  function handleError(error) {
    if (error.response?.status === 401) {
      navigate(`/signin`);
      toast.error("Your session has expired. Please login.");
    } else {
      toast.error(
        error.response?.data?.message || error.message || "An error occurred."
      );
    }
  }

  function rhandle(e) {
    const { id, value, type, checked } = e.target;
    setForm((prev) => ({
      ...prev,
      [id]: type === "checkbox" ? checked : value,
    }));
  }

  return (
    <Modal show={isOpen} onHide={onRequestClose} centered>
      <Modal.Header closeButton className="hm-card-header">
        <Modal.Title className="hm-card-title">
          <i className="material-icons">local_offer</i>
          {categoryId ? "Update Booking Category" : "Add Booking Category"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-4">
        {loading && <div className="loading"></div>}
        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label htmlFor="name" className="form-label small fw-semibold">
              Category Name <span className="text-danger">*</span>
            </label>
            <input
              className="form-control"
              id="name"
              type="text"
              placeholder="e.g. Pilots, Cabin Crew, FATA Pilots, ATCOs"
              value={form.name}
              onChange={rhandle}
              required
            />
          </div>

          <div className="mb-4">
            <label htmlFor="description" className="form-label small fw-semibold">
              Description
            </label>
            <textarea
              className="form-control"
              id="description"
              placeholder="Brief description of this booking category..."
              value={form.description}
              onChange={rhandle}
              rows="3"
            />
          </div>

          <div className="d-flex justify-content-end gap-2">
            <Button
              variant="secondary"
              className="rounded-pill px-4"
              onClick={onRequestClose}
              disabled={loading}
            >
              Cancel
            </Button>
            <button type="submit" className="btn-hm-primary" disabled={loading}>
              <i className="material-icons" style={{ fontSize: "1rem" }}>save</i>
              {categoryId ? "Update Category" : "Save Category"}
            </button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default AddBookingCategory;
